import request, { Methods, withToken } from "../../../../utils/request";
import { getUserCompany } from "../../../../utils/constants";

//* ACTIONTYPES --------------------------------------------
export const POST_POSITION_REQUEST = "POST_POSITION_REQUEST";
export const POST_POSITION_SUCCESS = "POST_POSITION_SUCCESS";
export const POST_POSITION_ERROR = "POST_POSITION_ERROR";

//* ACTIONS ------------------------------------------------
export const postPositionRequest = (payload = {}, callback) => ({
  type: POST_POSITION_REQUEST,
  payload,
  callback,
});

export const postPositionSuccess = () => ({
  type: POST_POSITION_SUCCESS,
});

export const postPositionError = (error) => ({
  type: POST_POSITION_ERROR,
  payload: error,
});

//* REQUEST SERVICE ---------------------------------------
export const postPositionServiceRequest = async (data) => {
  const options = await withToken({
    method: Methods.POST,
    headers: { CompanyId: await getUserCompany() },
    data,
  });

  return request("/positions", options);
};
